// @module Eureka.MaxaPartPicker.MaxaPartPicker
define('PartPickerPagination'
    , [
        'partspickerpagination.tpl'

        , 'Eureka.MaxaPartPicker.MaxaPartPicker.SS2Model'
        , 'Eureka.MaxaPartPicker.MaxaPartPicker.Model'

        , 'Backbone'
    ]
    , function (
        partspickerpagination
        , MaxaPartPickerSS2Model
        , MaxaPartPickerModel
        , Backbone
    ) {
        'use strict';

        // @class Eureka.MaxaPartPicker.MaxaPartPicker.View @extends Backbone.View
        return Backbone.View.extend({

            template: partspickerpagination

            , initialize: function (options) {

            }

            , events: {
                'change [data-action="page-view"]': 'pageView'
            }

            , bindings: {}

            , childViews: {}

            , pageView: function (e) {
                for(var i=0; i < e.currentTarget.length; i++){
                    if(e.currentTarget[i].selected === true) {
                        let params = new URLSearchParams(window.location.hash.substr(1))

                        params.set("pageSize", e.currentTarget[i].value)

                        params.delete("page")
                        window.location.href = window.location.pathname + "#" + params.toString()

                    }
                }
            }


            //@method getContext @return Eureka.MaxaPartPicker.MaxaPartPicker.View.Context
            , getContext: function getContext() {
                let hash = window.location.hash.substr(1);
                let hashSplit = hash.split('&').reduce(function (res, item) {
                    let parts = item.split('=');
                    res[parts[0]] = parts[1];
                    return res;
                }, {});
                let options = [
                    {name: '12 per page', eventName: "12"},
                    {name: '24 per page', eventName: "24"},
                    {name: "48 per page", eventName: "48"},
                    {name: "96 per page", eventName: "96"}
                ]
                if(hashSplit.pageSize){
                    for(let i=0; i < options.length; i++){
                        if(options[i].eventName === hashSplit.pageSize){
                            options[i].isSelected = true
                            break;
                        }
                    }
                }else{
                    for(let i=0; i < options.length; i++){
                        options[i].isSelected = (options[i].eventName === "24")
                    }
                }
                return {
                    options: options
                };
            }
        });
    });
